import { render, staticRenderFns } from "./analizraporu.vue?vue&type=template&id=12525c0a&"
import script from "./analizraporu.vue?vue&type=script&lang=js&"
export * from "./analizraporu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports